// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__aAYZn","row":"Node_row__F54DY","label":"Node_label__ObnPc","footer":"Node_footer__3PuoZ"};